var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsyncEffect } from 'ii-react-sdk/hooks';
import { SimpleErrorModal } from 'ii-react-sdk/modal_components';
import React, { createContext, useContext, useState } from 'react';
import { useParams } from 'react-router';
import downloadFile from '~/utils/downloadFile';
import getComparisonById from './actions/fetchComparison';
import getDocumentData from './actions/fetchDocument';
const ComparisonContext = createContext({});
const ComparisonProvider = (props) => {
    const { id: comparisonId } = useParams();
    const [isInitializing, setIsInitializing] = useState(true);
    const [comparisonDocuments, setComparisonDocuments] = useState([]);
    const [anchorDocId, setAnchorDocId] = useState('');
    const [isErrorModalShowing, setIsErrorModalShowing] = useState(false);
    const [errorModalMessage, setErrorModalMessage] = useState('');
    useAsyncEffect(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!comparisonId)
                return;
            setIsInitializing(true);
            const plainDocs = yield getComparisonById(comparisonId);
            const docDataPromises = plainDocs.map((doc) => __awaiter(void 0, void 0, void 0, function* () {
                const [data, blob] = yield Promise.all([getDocumentData(doc), downloadFile(doc.fileId, 'UPLOAD_FILES_BUCKET')]);
                return Object.assign(Object.assign({}, doc), { data, blob });
            }));
            const docsWithData = yield Promise.all(docDataPromises);
            window.debugLogger({ docsWithData });
            setComparisonDocuments(docsWithData);
            if (docsWithData.length)
                setAnchorDocId(docsWithData[0].fileId);
            setIsInitializing(false);
        }
        catch (e) {
            console.error(e);
            setErrorModalMessage(e.message);
            setIsErrorModalShowing(true);
        }
    }), [comparisonId]);
    const value = {
        isInitializing,
        comparisonDocuments,
        anchorDocId,
        setAnchorDocId,
    };
    return React.createElement(React.Fragment, null,
        React.createElement(ComparisonContext.Provider, Object.assign({ value: value }, props)),
        React.createElement(SimpleErrorModal, { isModalShowing: isErrorModalShowing, errorMessage: errorModalMessage }));
};
const useComparison = () => {
    const ctx = useContext(ComparisonContext);
    if (ctx === undefined) {
        throw new Error('ComparisonContext can only be used under the ComparisonProvider');
    }
    return ctx;
};
export { useComparison, ComparisonProvider, };
